var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("mountboard-colours", {
        attrs: { xl: "", horizontal: "" },
        model: {
          value: _vm.selectedBoard,
          callback: function ($$v) {
            _vm.selectedBoard = $$v
          },
          expression: "selectedBoard",
        },
      }),
      _c("hr"),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "6", "offset-sm": "6" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "mb-3",
                  attrs: {
                    variant: "success",
                    block: "",
                    size: "lg",
                    disabled: _vm.addingToCart,
                  },
                  on: { click: _vm.addToCart },
                },
                [
                  _c("i", { staticClass: "material-icons mr-2" }, [
                    _vm._v("shopping_cart"),
                  ]),
                  _vm._v(
                    "Add to Cart \n(£" +
                      _vm._s(_vm.totalPrice) +
                      " " +
                      _vm._s(_vm.vatMode) +
                      " VAT)"
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }